import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import { searchInvoices } from 'Shared/util/web-api';
import { useTranslation } from 'Shared/util/custom-hooks';
import { formatDate, formatAmount } from 'Shared/util/formatters';
import { translateColumns } from 'Shared/util/translations';
import Page from 'Shared/components/page/page';
import { ColumnTypes } from 'Shared/components/tables/data-table';
import BasicInvoiceTable from './basic-invoice-table';


const columns = [{
  title: 'invoiceNumber',
  key: 'invoiceNumber',
}, {
  title: 'reference_number',
  key: 'referenceNumber',
}, {
  title: 'customer',
  key: 'debtor',
}, {
  title: 'invoiceDate',
  key: 'invoiceDate',
  type: ColumnTypes.Date,
  formatter: (d) => formatDate(d),
}, {
  title: 'dueDate',
  key: 'dueDate',
  type: ColumnTypes.Date,
  formatter: (d) => formatDate(d),
  hiddenMobile: true,
}, {
  title: 'totalAmount',
  key: 'totalAmount',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
  footer: {
    sum: true,
  },
}, {
  title: 'remainingAmount',
  key: 'remainingAmount',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
  footer: {
    sum: true,
  },
  hiddenMobile: true,
}, {
  title: 'currency',
  key: 'currencyCode',
  footer: {
    groupBy: true,
  },
}, {
  title: 'status',
  key: 'status',
}];


const SearchResultPage = ({
  registerPromise,
  location: { search },
}) => {
  const [invoices, setInvoices] = useState([]);
  const [searchTerms, setSearchTerms] = useState('');
  const [loading, setLoading] = useState(true);
  const t = useTranslation(x => x.search);
  const tg = useTranslation(x => x.global);

  useEffect(() => {
    const terms = new URLSearchParams(search).get('terms');

    if (terms) {
      setLoading(true);
      setSearchTerms(terms);

      registerPromise(searchInvoices(terms))
        .then((result) => setInvoices(result))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [search]);

  const headerText = (searchTerms ? t.format(t.searchResultsFor, { searchTerms }) : t.searchResults);

  return (
    <Page title={headerText}>
      <BasicInvoiceTable
        loading={loading}
        columns={translateColumns(columns, tg)}
        rows={invoices}
      />
    </Page>
  );
};

SearchResultPage.propTypes = {
  registerPromise: PropTypes.func.isRequired,
  location: PropTypes.shape({ search: PropTypes.string }).isRequired,
};

export default makeComponentTrashable(SearchResultPage);
